const OnlineGameUI = {
    elements: {},

    init: function () {
        this.cacheElements();
        // Hide offline score badge if it exists
        if (this.elements.scoreBadge) {
            this.elements.scoreBadge.style.display = 'none';
        }
    },

    // [NEW] Setup listeners for the room
    setupRoomListeners: function (room) {
        if (!room) {
            console.error("[OnlineGameUI] Cannot setup listeners: room is null");
            return;
        }

        console.log("[OnlineGameUI] Setting up room listeners...");

        room.onStateChange((state) => {
            // [NEW] Bind room to this for easier access in loop
            this.currentRoom = room;
            // Main game loop update
            this.updateGameLoop(state, room.sessionId);

            // Show result if status changed from playing to result
            if (state.status === "result") {
                this.showResult(state, room.sessionId);
            }

            // [ROULETTE] Show voting UI if status is 'voting'
            if (state.status === "voting" && state.mode === "roulette") {
                this.showRouletteVoting(state, room.sessionId);
            }

            // Final results
            if (state.status === "final_results") {
                this.showFinalResults(state);
            }
        });

        // [ROULETTE] Listen for roulette-specific events
        room.onMessage("rouletteEvent", (data) => {
            console.log("[Roulette Event]", data.type, data.message);
            if (window.AccessibilityManager) {
                window.AccessibilityManager.announce(data.message, "assertive");
            }
            this.showRouletteMessage(data);
        });

        // Initial cache ensure
        this.ensureElements();
    },

    cacheElements: function () {
        this.elements = {
            resultsList: document.getElementById('results-list'),
            scoreBadge: document.getElementById('offline-score-badge'),
            questionText: document.getElementById('question-text'),
            optionsContainer: document.getElementById('options-container'),
            timeDisplay: document.getElementById('time-display'),
            timerProgress: document.getElementById('timer-progress'),
            categoryDisplay: document.getElementById('category-display'),
            p1Name: document.getElementById('p1-name'),
            p1Score: document.getElementById('p1-score'),
            p2Name: document.getElementById('p2-name'),
            p2Score: document.getElementById('p2-score'),
            resultOverlay: document.getElementById('result-overlay'), // If exists
        };

        // **CHAT RE-TARGET**
        // **CHAT RE-TARGET**
        // If chat exists (created in Lobby), move it to game-screen or re-init
        if (window.ChatManager && window.ChatManager.container) {
            const activeRoom = this.currentRoom || (window.multiplayer && window.multiplayer.room);
            if (activeRoom) {
                // Re-init to update listeners if needed, default to body (fixed position)
                // [FIX] Chat visible and functional during game
                window.ChatManager.init(activeRoom, { startHidden: false });

                // [NEW] Mobile Chat Constraint
                if (window.MobileManager && window.MobileManager.isMobile) {
                    console.log("[OnlineGameUI] Mobile detected, enabling Mic-Only mode.");
                    window.ChatManager.setMobileMicOnly(true);
                } else {
                    window.ChatManager.setMobileMicOnly(false);
                }
            }
        }
    },

    lastQuestionText: null,
    isTyping: false,
    typewriterTimeout: null,

    updateGameLoop: function (state, mySessionId) {
        try {
            // [FIX] Ensure elements are cached (self-healing)
            this.ensureElements();

            // [NEW] Starting State (Geri Sayım) - HIDE OVERLAY AS REQUESTED
            if (state.status === "starting") {
                // [FIX] Consistently hide score badge in online mode
                if (this.elements.scoreBadge) {
                    this.elements.scoreBadge.style.display = 'none';
                }

                if (this.elements.optionsContainer) {
                    this.elements.optionsContainer.innerHTML = '';
                }

                // [ROULETTE] Show special starting message
                if (state.mode === 'roulette') {
                    if (this.elements.categoryDisplay) {
                        this.elements.categoryDisplay.innerText = '🎰 GADDAR RULET';
                    }
                    if (this.elements.questionText) {
                        this.elements.questionText.innerHTML = '<span style="font-size:2rem; animation: pulse 1s infinite">GADDAR RULET BAŞLIYOR!</span>';
                    }
                    return;
                }

                if (this.elements.categoryDisplay) {
                    this.elements.categoryDisplay.innerText = "HAZIRLANIN!";
                }

                // If it's wheel mode, don't return early so we can see the wheel
                if (state.mode !== 'wheel') {
                    return;
                }
            }

            // [ROULETTE] During voting, don't run the normal game loop
            if (state.status === 'voting' && state.mode === 'roulette') {
                return;
            }

            // [FIX] Always ensure score badge is hidden in playing/result states too
            if (this.elements.scoreBadge) {
                this.elements.scoreBadge.style.display = 'none';
            }

            if (!state.currentQuestion) return;

            // 1. Soru Metni (Sadece değiştiyse ve yazmıyorsak daktilo efekti başlat)
            if (this.elements.questionText) {
                const questionC = state.currentQuestion;
                if (questionC && questionC.text) {
                    if (this.lastQuestionText !== questionC.text) {
                        this.lastQuestionText = questionC.text;
                        this.resultSoundPlayed = false; // [RESET] For new question

                        // [ROULETTE] Play gun handing sound at start of each question
                        if (state.mode === 'roulette' && window.audio) {
                            window.audio.playSound('gun_hand');
                        }

                        if (window.AccessibilityManager) {
                            window.AccessibilityManager.announce("Yeni soru: " + questionC.text, "assertive");
                        }

                        this.startTypewriter(questionC.text);
                    }
                } else {
                    // Waiting for question data
                    if (!this.loadingStartTime) this.loadingStartTime = Date.now();

                    // 4 Saniye bekledikten sonra hala veri yoksa detay göster
                    if (Date.now() - this.loadingStartTime > 4000) {
                        const debugInfo = {
                            status: state.status,
                            cat: state.category,
                            qRaw: questionC ? 'Object' : 'Null',
                            qText: questionC?.text
                        };
                        this.elements.questionText.innerHTML = `⚠️ Soru Verisi Alınamadı!<br><span style="font-size:0.8rem; opacity:0.8">${JSON.stringify(debugInfo)}</span>`;
                        this.elements.questionText.style.color = "#e74c3c"; // Red
                    } else {
                        // Only show loading if empty
                        if (this.elements.questionText.innerText === 'Soru yükleniyor...') {
                            // Keep it
                        } else if (this.elements.questionText.innerText === '') {
                            this.elements.questionText.innerText = "Soru yükleniyor...";
                        }
                        this.elements.questionText.style.color = ""; // Reset
                    }
                }
            } else {
                if (this.loadingStartTime) this.loadingStartTime = null; // Reset if element missing
            }

            // 2. Kategori Badge
            if (this.elements.categoryDisplay && state.category) {
                let catName = state.category.replace(/_/g, ' ').toLocaleUpperCase('tr-TR');
                this.elements.categoryDisplay.innerText = catName;
            }

            // 3. Şıklar (Sadece yazma bittiyse veya zaten render edildiyse)
            // [FIX] Sadece 'playing' veya 'starting' durumunda renderOptions çalışsın.
            // [ROULETTE FIX] Oylama sırasında şıkların çıkmaması için 'voting' durumunda engelle.
            if (!this.isTyping && (state.status === "playing" || state.status === "starting") && state.status !== "voting") {
                try {
                    this.renderOptions(state, mySessionId);
                } catch (err) { console.error("RenderOptions Error:", err); }
            }

            // 4. Timer
            this.updateTimer(state.countdown, state);

            // 5. Skorlar
            try {
                this.updateScores(state, mySessionId);
            } catch (err) { console.error("UpdateScores Error:", err); }

            // 6. Soru Sayacı [NEW]
            this.updateQuestionCount(state);

            // 7. Multi-Player Character Icons [NEW]
            const participantsContainer = document.getElementById('game-participants-chars');
            if (participantsContainer && state.players) {
                // Sadece üye sayısı değişince veya ilk kez render edelim (basitlik için temizle-doldur)
                const playerCount = state.players.size;
                const currentIcons = participantsContainer.querySelectorAll('.player-char-icon').length;

                if (playerCount !== currentIcons) {
                    participantsContainer.innerHTML = '';
                    state.players.forEach((player, sessionId) => {
                        const charBox = document.createElement('div');
                        charBox.className = 'player-char-icon';
                        const isMe = sessionId === mySessionId;

                        Object.assign(charBox.style, {
                            width: '40px', height: '40px', background: 'rgba(0,0,0,0.4)',
                            borderRadius: '50%', border: isMe ? '2px solid var(--accent-gold)' : '1px solid rgba(255,255,255,0.3)',
                            overflow: 'hidden', display: 'flex', alignPosition: 'center', justifyContent: 'center',
                            boxShadow: isMe ? '0 0 10px rgba(255, 215, 0, 0.3)' : 'none',
                            transition: 'all 0.3s ease'
                        });

                        const charImg = document.createElement('img');
                        const charFile = player.character || 'karakter1.png';
                        charImg.src = new URL(`../../assets/images/characters/${charFile}`, import.meta.url).href;
                        Object.assign(charImg.style, { width: '100%', height: '100%', objectFit: 'contain' });

                        charBox.appendChild(charImg);
                        participantsContainer.appendChild(charBox);
                    });
                }
            }
        } catch (e) {
            console.error("OnlineGameUI Loop Error:", e);
            // Fallback: Show static text if loop crashes
            if (this.elements.questionText) {
                this.elements.questionText.innerText = (state && state.currentQuestion && state.currentQuestion.text)
                    ? state.currentQuestion.text
                    : "Hata oluştu: " + e.message;
            }
        }
    },

    // [NEW] Helper to check and repair DOM cache
    ensureElements: function () {
        if (!this.elements.questionText || !document.body.contains(this.elements.questionText)) {
            // Element is missing or detached from DOM
            console.log("[OnlineGameUI] Elements missing or detached. Re-caching...");
            this.cacheElements();
        }
    },

    startTypewriter: function (text) {
        if (this.typewriterTimeout) clearTimeout(this.typewriterTimeout);
        this.isTyping = false;

        if (!this.elements.questionText) return;

        // [FIX] Reset text color and style in case it was modified by countdown
        this.elements.questionText.style.color = "var(--question-text-color, #fff)";

        // [ANIMATION] Fast Entry
        this.elements.questionText.classList.remove('question-entry-fast');
        void this.elements.questionText.offsetWidth; // Trigger Reflow
        this.elements.questionText.classList.add('question-entry-fast');

        this.elements.questionText.innerHTML = text; // Just set text directly for now to fix overlap
        this.timeUpPlayed = false; // [RESET] Reset timeUp flag for new question

        // [FIX] Use active room for state
        const activeRoom = this.currentRoom || (window.multiplayer && window.multiplayer.room);
        if (activeRoom && activeRoom.state) {
            const state = activeRoom.state;
            // Ensure current question matches text (simple check)
            if (state.currentQuestion && state.currentQuestion.text === text) {
                this.renderOptions(state, activeRoom.sessionId);
            }
        }
    },

    renderOptions: function (state, mySessionId) {
        if (!this.elements.optionsContainer || this.isTyping) return;

        const myPlayer = state.players.get(mySessionId);
        const myAnswer = myPlayer ? myPlayer.lastAnswer : -1;
        const isTimeUp = state.countdown <= 0;

        // Mevcut buton sayısını kontrol et
        const currentButtons = this.elements.optionsContainer.querySelectorAll('.option-btn');

        // [FIX] Check for "dirty" result buttons (from previous round) or placeholders ("Seçenek Yükleniyor...")
        const isPlaceholder = Array.from(currentButtons).some(btn =>
            btn.innerText.includes("Yükleniyor...")
        );

        const isDirty = isPlaceholder || Array.from(currentButtons).some(btn =>
            btn.classList.contains('correct') ||
            btn.classList.contains('wrong') ||
            btn.disabled // Result buttons are disabled
        );

        // Eğer hiç yoksa, şık yazıları farklıysa VEYA dirty ise redraw yap.
        // Not: Text kontrolü karmaşık olabilir, dirty check yeterli.
        if (currentButtons.length === 0 || isDirty) {
            this.elements.optionsContainer.innerHTML = '';
            state.currentQuestion.options.forEach((opt, idx) => {
                const btn = document.createElement('button');
                btn.className = 'option-btn';
                btn.innerText = opt;
                // [FIX] Ensure click handler is always attached fresh
                btn.onclick = () => {
                    if (window.multiplayer && window.multiplayer.room && !this.isTyping) {
                        window.multiplayer.room.send("answer", idx);
                    }
                };
                this.elements.optionsContainer.appendChild(btn);
            });
        }

        // Buton Durumlarını Güncelle (Yeniden oluşturulmuş olabilir)
        const buttons = this.elements.optionsContainer.querySelectorAll('.option-btn');
        buttons.forEach((btn, idx) => {
            // [FIX] Ensure fresh onclick if reusing (though we likely rebuilt)
            btn.onclick = () => {
                const activeRoom = this.currentRoom || (window.multiplayer && window.multiplayer.room);
                if (activeRoom && !this.isTyping) {
                    activeRoom.send("answer", idx);
                }
            };

            if (myAnswer !== -1) {
                // Cevap verilmiş -> Kilitle
                btn.disabled = true;
                btn.style.pointerEvents = 'none';
                if (idx === myAnswer) {
                    btn.classList.add('selected');
                } else {
                    btn.classList.add('locked-others');
                    btn.style.opacity = '0.3';
                }
            } else if (isTimeUp) {
                // Süre bitti -> Kilitle
                btn.disabled = true;
                btn.style.pointerEvents = 'none';
                btn.style.opacity = '0.5';
            } else {
                // Bekleme durumu
                btn.disabled = false;
                btn.style.pointerEvents = 'auto';
                btn.classList.remove('selected', 'locked-others', 'correct', 'wrong'); // Extra safety
                btn.style.opacity = '1';
                btn.style.color = ''; // Reset color
                btn.style.backgroundColor = ''; // Reset bg
                btn.style.borderColor = ''; // Reset border
            }
        });
    },

    showResult: function (state, mySessionId) {
        if (!this.elements.optionsContainer) return;

        const buttons = this.elements.optionsContainer.querySelectorAll('button');
        const correct = state.currentQuestion.correct;

        // [SOUND] Play sound based on my result (ONCE)
        if (!this.resultSoundPlayed) {
            const myPlayer = state.players.get(mySessionId);
            if (myPlayer) {
                console.log(`[SoundDebug] Me: ${myPlayer.name}, Ans: ${myPlayer.lastAnswer}, Correct: ${correct}`);

                // [SOUND OVERLAP FIX - V3]
                // 1. GADDAR RULET: Kurban (yanlış yapan) doğru/yanlış sesi duymasın, sadece oylama sonucunu duysun.
                const isRouletteVictim = (state.mode === 'roulette' && mySessionId === state.victimSessionId);

                if (isRouletteVictim) {
                    console.log("[Audio] Roulette victim detected, suppressing result sounds.");
                    this.resultSoundPlayed = true;
                    return; // Victims don't hear correct/wrong sounds here
                }

                // 2. KLASİK BİLGİ / DİĞER: Süre bittiyse ve cevap vermediysek yanlış sesini engelle.
                if (myPlayer.lastAnswer == correct) {
                    console.log("[Audio] Playing Correct Sound via AudioManager");
                    if (window.audio) window.audio.playSound('correct');
                    this.resultSoundPlayed = true;
                } else {
                    // Answered Wrong OR Timeout
                    // [SOUND OVERLAP FIX] If timeUp played OR it's a timeout (lastAnswer -1), skip wrong sound
                    const isTimeout = (state.countdown <= 0 && myPlayer.lastAnswer === -1);
                    if (!this.timeUpPlayed && !isTimeout) {
                        console.log("[Audio] Playing Wrong Sound via AudioManager");
                        if (window.audio) window.audio.playSound('wrong');
                    } else {
                        console.log("[Audio] Suppressing wrong sound due to timeout/timeUpPlayed");
                    }
                    this.resultSoundPlayed = true;
                }
            } else {
                console.warn("[SoundDebug] MyPlayer not found!", mySessionId);
            }
        }

        buttons.forEach((btn, idx) => {
            btn.onclick = null; // Tıklamayı kapat
            btn.style.cursor = 'default';

            // [FIX] Reset text to prevent duplicate icons
            btn.innerText = state.currentQuestion.options[idx];

            if (idx === correct) {
                // Herkese doğru şıkkı göster
                btn.classList.add('correct'); // Yeşil class'ı CSS'de tanımlı olmalı
                btn.style.backgroundColor = '#2ecc71'; // Fallback
                btn.style.borderColor = '#27ae60';
                btn.style.color = 'white';
                btn.style.opacity = '1';
                btn.innerHTML += ' ✅';
            } else {
                // Yanlış cevap kontrolü
                // Eğer ben bunu seçtiysem ve yanlışsa kırmızı yap
                const myPlayer = state.players.get(mySessionId);
                if (myPlayer && myPlayer.lastAnswer === idx) {
                    btn.classList.add('wrong');
                    btn.style.backgroundColor = '#e74c3c'; // Fallback Red
                    btn.style.borderColor = '#c0392b';
                    btn.style.color = 'white';
                    btn.style.opacity = '1';
                    btn.innerHTML += ' ❌';
                } else {
                    btn.style.opacity = '0.3'; // Diğer şıklar soluk
                }
            }
        });
    },

    showFinalResults: function (state) {
        // [SOUND] Game Over / Scoreboard Sound
        if (window.audio && window.OnlineGameUI && !window.OnlineGameUI.gameOverSoundPlayed) {
            window.audio.playSound('game_over_online');
            window.OnlineGameUI.gameOverSoundPlayed = true;
        }

        // [FIX] Hide header info during results
        if (this.elements.timeDisplay) this.elements.timeDisplay.parentElement.style.opacity = '0';
        if (this.elements.categoryDisplay) this.elements.categoryDisplay.style.opacity = '0';

        // Hide Question Index display if it exists in header
        const questionIndexEl = document.querySelector('.header-question-info');
        if (questionIndexEl) questionIndexEl.style.opacity = '0';

        if (this.elements.questionText) {
            this.elements.questionText.innerHTML = `<div style="color:var(--accent-gold); font-size:2rem;">🏁 OYUN BİTTİ!</div>`;
        }

        // [NEW] Update User Stats (Wins/Losses) on Game Over
        if (window.AuthManager && window.multiplayer && window.multiplayer.room && state && state.players) {
            const mySessionId = window.multiplayer.room.sessionId;
            const myPlayer = state.players.get(mySessionId);

            if (myPlayer) {
                // Online modes usually don't track correct/wrong explicitly on the client player object identically to offline,
                // but score is there. We'll pass the score.
                // For Roulette, we might extrapolate 'wins' vs 'losses' if player is eliminated.
                // Normally we pass points, correct (Win), wrong (Loss).
                let points = myPlayer.score || 0;

                // Estimate Wins/Losses for Online Games
                // If Roulette and alive = win, if dead = loss. 
                // If Quiz/Wheel, we can try to find correct count if the server tracks it.
                let wins = myPlayer.correctAnswers || 0; // if server shares this
                let losses = myPlayer.wrongAnswers || 0;   // if server shares this

                if (state.mode === 'roulette') {
                    if (myPlayer.isAlive) {
                        wins = 1;
                        losses = 0;
                    } else {
                        wins = 0;
                        losses = 1;
                    }
                } else if (!myPlayer.correctAnswers && !myPlayer.wrongAnswers) {
                    // Fallback for Classical/Wheel if stats aren't explicitly passed down: 
                    // Win if score > 0? Let's just pass points to DB for now.
                    // A cleaner way is if the game logic sets it. We assume > 0 means a win for stats.
                    wins = points > 0 ? 1 : 0;
                    losses = points === 0 ? 1 : 0;
                }

                window.AuthManager.addStats(points, wins, losses, state.mode);
                console.log(`[OnlineGameUI] Stats Saved: Points:${points}, Wins:${wins}, Losses:${losses}, Mode:${state.mode}`);
            }
        }

        // 1. Hide Options & Show "Return to Lobby"
        if (this.elements.optionsContainer) {
            this.elements.optionsContainer.innerHTML = '';

            const actionContainer = document.createElement('div');
            Object.assign(actionContainer.style, {
                display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '1rem', marginTop: '1rem'
            });

            // [FIX] Remove Toggle Button on Game Over
            const toggleBtn = document.getElementById('toggle-scoreboard-btn');
            if (toggleBtn) toggleBtn.remove();

            // [FIX] Hide Scoreboard Container and prevent it from being shown
            const scoreContainer = document.getElementById('multi-score-container');
            if (scoreContainer) {
                scoreContainer.style.display = 'none';
            }

            // [FIX] Hide Chat Button on Game Over (Chat is visible anyway)
            const chatBtn = document.getElementById('header-chat-btn');
            if (chatBtn) chatBtn.style.display = 'none';

            // [NEW] Show Scores in Center "Inside Page"
            if (state && state.players) {
                const resultsDiv = document.createElement('div');
                Object.assign(resultsDiv.style, {
                    width: '100%', background: 'rgba(0,0,0,0.5)', borderRadius: '12px', padding: '1rem',
                    marginBottom: '1rem', display: 'flex', flexDirection: 'column', gap: '0.5rem'
                });

                // Sort players by score
                const sortedPlayers = Array.from(state.players.values()).sort((a, b) => b.score - a.score);

                sortedPlayers.forEach(p => {
                    const pRow = document.createElement('div');
                    Object.assign(pRow.style, {
                        display: 'flex', justifyContent: 'space-between', color: '#fff', fontSize: '1.2rem',
                        borderBottom: '1px solid rgba(255,255,255,0.1)', paddingBottom: '5px'
                    });

                    const nameSpan = document.createElement('span');
                    nameSpan.textContent = p.name;

                    const scoreSpan = document.createElement('span');
                    scoreSpan.style.color = "var(--accent-gold)";
                    scoreSpan.style.fontWeight = "bold";
                    scoreSpan.textContent = p.score;

                    pRow.appendChild(nameSpan);
                    pRow.appendChild(scoreSpan);
                    resultsDiv.appendChild(pRow);
                });
                actionContainer.appendChild(resultsDiv);
            }

            const homeBtn = document.createElement('button');
            homeBtn.innerText = "LOBİYE DÖN";
            Object.assign(homeBtn.style, {
                padding: '1rem 2rem', fontSize: '1.2rem', fontWeight: 'bold',
                color: '#000', background: 'var(--accent-gold)', border: 'none',
                borderRadius: '8px', cursor: 'pointer', boxShadow: '0 0 20px rgba(255, 215, 0, 0.4)'
            });
            homeBtn.onclick = () => {
                const activeRoom = this.currentRoom || (window.multiplayer && window.multiplayer.room);
                if (activeRoom) {
                    // [FIX] Stay in room and request return to waiting state instead of leaving
                    activeRoom.send("requestReturnToLobby");
                } else if (window.onlineManager) {
                    window.onlineManager.leaveRoom();
                }
            };

            actionContainer.appendChild(homeBtn);
            this.elements.optionsContainer.appendChild(actionContainer);
        }

        // 2. Scoreboard auto-display removed as requested
        // Scoreboard is accessible via the trophy icon in the header
    },

    updateTimer: function (val, state) {
        if (this.elements.timeDisplay) {
            this.elements.timeDisplay.innerText = val;

            // [SOUND] Time Up
            if (val === 0 && this.lastTimerVal !== 0) {
                const myPlayer = state.players.get(window.multiplayer?.room?.sessionId);
                if (window.audio && (!myPlayer || myPlayer.lastAnswer === -1)) {
                    window.audio.playSound('time_up');
                    this.timeUpPlayed = true; // [FLAG] Mark that timeUp played to avoid result sound overlap
                }
            }
            this.lastTimerVal = val;

            // [VISUAL] Pop effect on change
            this.elements.timeDisplay.style.transform = 'scale(1.2)';
            setTimeout(() => { if (this.elements.timeDisplay) this.elements.timeDisplay.style.transform = 'scale(1)'; }, 100);

            // [COLOR] Change color based on urgency
            if (val <= 5) {
                this.elements.timeDisplay.style.color = '#ff5252';
                this.elements.timeDisplay.classList.add('pulse-timer');
            } else {
                this.elements.timeDisplay.style.color = '#fff';
                this.elements.timeDisplay.classList.remove('pulse-timer');
            }
        }

        if (this.elements.timerProgress) {
            const turnTime = (state && state.turnTime) ? state.turnTime : 20;
            const pct = Math.max(0, (val / turnTime) * 100);

            // [FIX] Ensure smooth transition
            this.elements.timerProgress.style.width = `${pct}%`;

            // [COLOR] Gradient shift
            if (pct > 50) {
                this.elements.timerProgress.style.background = 'linear-gradient(90deg, #2ecc71, #27ae60)';
            } else if (pct > 25) {
                this.elements.timerProgress.style.background = 'linear-gradient(90deg, #f1c40f, #f39c12)';
            } else {
                this.elements.timerProgress.style.background = 'linear-gradient(90deg, #e74c3c, #c0392b)';
            }
        }
    },

    // [FIX] Question Count Update
    updateQuestionCount: function (state) {
        const countEl = document.getElementById('question-count-display');
        if (countEl && state) {
            // [FIX] Use 'questionIndex' based on QuizRoom (not currentQuestionIndex)
            const current = state.questionIndex || 1;
            const total = 10;
            countEl.innerText = `${current} / ${total}`;
        }
    },

    updateScores: function (state, mySessionId) {
        // [DYNAMIC FONT SIZE]
        let currentSize = '14pt';
        if (window.state && window.state.scoreFontSize) {
            currentSize = window.state.scoreFontSize;
        } else {
            const saved = localStorage.getItem('gaddar_score_size');
            if (saved) currentSize = saved.endsWith('pt') ? saved : (saved + 'pt');
        }

        // [DYNAMIC SCOREBOARD]
        let scoreContainer = document.getElementById('multi-score-container');

        // [FIX] Hide floating scoreboard in Lobby (waiting state)
        if (state.status === 'waiting') {
            if (scoreContainer) scoreContainer.style.display = 'none';
            // Also hide toggle button in lobby
            const toggleBtn = document.getElementById('toggle-scoreboard-btn');
            if (toggleBtn) toggleBtn.style.display = 'none';

            const chatBtn = document.getElementById('header-chat-btn');
            if (chatBtn) chatBtn.style.display = 'none';

            return;
        }

        // [NEW] HEADER BUTTONS CONTAINER (Trophy + Chat)
        // [MODERN FIX] HEADER CONTROLS CONTAINER
        // Consolidate buttons into a single flex container to prevent overlap
        // [FIX] REMOVED separate fixed container. Now integrated into main Header logic.
        // Remove old container if it exists to cleanup previous versions
        const oldContainer = document.getElementById('game-header-controls');
        if (oldContainer) oldContainer.remove();

        const headerRight = document.querySelector('.header-right');

        if (headerRight) {
            // 1. Trophy Button logic
            let toggleBtn = document.getElementById('toggle-scoreboard-btn');
            if (!toggleBtn) {
                toggleBtn = document.createElement('button');
                toggleBtn.id = 'toggle-scoreboard-btn';
                toggleBtn.className = 'header-btn'; // Use existing class for consistency
                toggleBtn.innerHTML = '<span class="icon">🏆</span>';
                Object.assign(toggleBtn.style, {
                    marginRight: '10px',
                    color: '#ffd700',
                    border: '1px solid rgba(255,215,0,0.3)',
                    background: 'rgba(0,0,0,0.5)'
                });

                toggleBtn.onclick = () => {
                    const sc = document.getElementById('multi-score-container');
                    if (sc) {
                        const isHidden = sc.style.display === 'none';
                        sc.style.display = isHidden ? 'flex' : 'none';
                        toggleBtn.style.background = isHidden ? 'rgba(255,215,0,0.2)' : 'rgba(0,0,0,0.5)';
                    }
                };

                // Insert as FIRST child to be LEFT of Sound button
                headerRight.insertBefore(toggleBtn, headerRight.firstChild);
            } else {
                toggleBtn.style.display = 'inline-flex';
            }

            // 2. Chat Button Logic (Reuse existing from Header.js)
            const chatBtn = document.getElementById('header-chat-btn');
            if (chatBtn) {
                chatBtn.style.display = 'inline-flex';
                // Add click handler if not already logic-bound (or overwrite to be safe)
                chatBtn.onclick = () => {
                    if (window.ChatManager) {
                        window.ChatManager.toggleMinimize(false);
                    }
                };
            }
        }

        // [NEW] ESC Key Support
        if (!OnlineGameUI._escListenerAttached) {
            document.addEventListener('keydown', (e) => {
                if (e.key === 'Escape') {
                    // Close Scoreboard
                    const sc = document.getElementById('multi-score-container');
                    if (sc && sc.style.display !== 'none') {
                        sc.style.display = 'none';
                        // Reset button style
                        const tBtn = document.getElementById('toggle-scoreboard-btn');
                        if (tBtn) tBtn.style.background = 'rgba(255,215,0,0.2)';
                    }
                    // Close Chat
                    if (window.ChatManager) window.ChatManager.toggleMinimize(true);
                }
            });
            OnlineGameUI._escListenerAttached = true;
        }

        if (!scoreContainer) {
            // Append to BODY to be outside game container
            scoreContainer = document.createElement('div');
            scoreContainer.id = 'multi-score-container';
            Object.assign(scoreContainer.style, {
                // Fixed position: Default RIGHT side
                position: 'fixed', top: '100px', right: '20px', left: 'auto',
                // Removed scale(0.9) for better readability
                transform: 'none', transformOrigin: 'top right',
                background: 'rgba(0,0,0,0.85)', padding: '0',
                borderRadius: '12px',
                backdropFilter: 'blur(10px)', border: '2px solid rgba(255,215,0,0.5)',
                display: 'none', // [FIX] Default Hidden as requested
                flexDirection: 'column', zIndex: '9999',
                minWidth: '300px',
                boxShadow: '0 10px 30px rgba(0,0,0,0.8)',
                overflow: 'hidden'
            });

            // [NEW] DRAG HEADER
            const header = document.createElement('div');
            Object.assign(header.style, {
                padding: '12px', background: 'rgba(255,215,0,0.1)',
                borderBottom: '1px solid rgba(255,215,0,0.2)',
                color: '#ffd700', fontWeight: 'bold',
                fontSize: currentSize, // [FIX] Dynamic Size
                cursor: 'grab', display: 'flex', justifyContent: 'space-between', alignItems: 'center',
                userSelect: 'none'
            });
            header.innerHTML = '<span>🏆 SKOR</span>';

            // DRAG LOGIC
            // Ensure header knows it can be disabled
            header.id = 'multi-score-header';

            const startDrag = (e) => {
                // If cursor is default, dragging is disabled (Game Over state)
                if (header.style.cursor === 'default') return;

                e.preventDefault();
                const startX = e.clientX, startY = e.clientY;
                const rect = scoreContainer.getBoundingClientRect();
                const offX = startX - rect.left, offY = startY - rect.top;

                const onMove = (mv) => {
                    scoreContainer.style.right = 'auto'; // [FIX] Prevent width stretching conflict
                    scoreContainer.style.bottom = 'auto'; // [FIX] Clear bottom if set
                    scoreContainer.style.left = (mv.clientX - offX) + 'px';
                    scoreContainer.style.top = (mv.clientY - offY) + 'px';
                    scoreContainer.style.transform = 'none';
                };
                const onUp = () => {
                    document.removeEventListener('mousemove', onMove);
                    document.removeEventListener('mouseup', onUp);
                    document.body.style.cursor = 'default';
                };
                document.addEventListener('mousemove', onMove);
                document.addEventListener('mouseup', onUp);
                document.body.style.cursor = 'grabbing';
            };

            header.onmousedown = startDrag;

            // Add Close Button (inside header)
            const closeBtn = document.createElement('button');
            closeBtn.innerHTML = '×';
            Object.assign(closeBtn.style, {
                background: 'none', border: 'none', color: '#aaa',
                fontSize: '1.5rem', cursor: 'pointer', lineHeight: '1', marginLeft: '10px'
            });
            closeBtn.onclick = (e) => {
                e.stopPropagation();
                scoreContainer.style.display = 'none';
            };
            header.appendChild(closeBtn);
            scoreContainer.appendChild(header);

            // Content Wrapper
            const content = document.createElement('div');
            content.id = 'multi-score-content';
            Object.assign(content.style, {
                padding: '15px', display: 'flex', flexDirection: 'column', gap: '8px'
            });
            scoreContainer.appendChild(content);

            document.body.appendChild(scoreContainer);
        } else {
            // [FIX] Ensure Header Size updates on re-renders if needed (though usually static)
            // Only update if explicit change request or new render?
            // Actually better to just update it always to be safe or rely on updateScoreFontSize
            const header = scoreContainer.querySelector('div:first-child');
            if (header) header.style.fontSize = currentSize;
        }

        // Update Content
        const content = document.getElementById('multi-score-content');
        if (content) {
            content.innerHTML = '';
            const players = Array.from(state.players.values()).sort((a, b) => b.score - a.score);

            players.forEach(p => {
                const row = document.createElement('div');
                Object.assign(row.style, {
                    display: 'flex', justifyContent: 'space-between', alignItems: 'center',
                    fontSize: currentSize, // [FIX] Dynamic Size
                    color: '#fff',
                    padding: '5px 0', borderBottom: '1px solid rgba(255,255,255,0.1)'
                });

                const isMe = (p.sessionId === mySessionId);
                const amIHost = (state.masterSessionId === mySessionId);
                const nameStyle = isMe ? 'color:var(--accent-gold); font-weight:bold;' : 'color:#ddd;';

                // Logic for kick button
                // Logic for kick button (handled in safe creation below)
                // [REMOVED] unsafe string construction

                // [SECURITY FIX] Safe DOM Creation
                const leftDiv = document.createElement('div');
                leftDiv.style.display = 'flex';
                leftDiv.style.alignItems = 'center';

                const nameSpan = document.createElement('span');
                nameSpan.style.cssText = nameStyle;
                nameSpan.innerText = `${p.name} ${isMe ? '(Sen)' : ''}`;
                leftDiv.appendChild(nameSpan);

                if (amIHost && !isMe) {
                    const kBtn = document.createElement('span');
                    kBtn.innerText = '🚫';
                    kBtn.title = 'Odadan At';
                    kBtn.style.cssText = 'cursor:pointer; margin-left:10px; font-size:0.9em; color:#e74c3c; padding:2px;';
                    kBtn.onclick = (e) => {
                        e.stopPropagation();
                        // Use Global LobbyManager Modal if available
                        if (window.LobbyManager && window.LobbyManager.showCustomConfirm) {
                            window.LobbyManager.showCustomConfirm(
                                "Oyuncu Atma",
                                `${p.name} adlı oyuncuyu odadan atmak istiyor musunuz?`,
                                () => { if (window.multiplayer.room) window.multiplayer.room.send("kickPlayer", p.sessionId); }
                            );
                        } else if (confirm(`${p.name} adlı oyuncuyu atmak istiyor musunuz?`)) {
                            // Fallback
                            if (window.multiplayer.room) window.multiplayer.room.send("kickPlayer", p.sessionId);
                        }
                    };
                    leftDiv.appendChild(kBtn);
                }

                const scoreSpan = document.createElement('span');
                scoreSpan.style.cssText = 'font-weight:bold; color:#fff;';
                scoreSpan.innerText = p.score;

                row.appendChild(leftDiv);
                row.appendChild(scoreSpan);
                content.appendChild(row);

            });
        }
    },

    // [NEW] Dynamic Score Font Update
    updateScoreFontSize: function (sizePt) {
        // Save state for next renders
        if (!window.state) window.state = {};
        window.state.scoreFontSize = sizePt;

        // Update Header
        const container = document.getElementById('multi-score-container');
        if (container) {
            const header = container.querySelector('div:first-child');
            if (header) header.style.fontSize = sizePt;
        }

        // Update Rows
        const rows = document.querySelectorAll('#multi-score-content > div');
        rows.forEach(r => r.style.fontSize = sizePt);
    },

    // ============================================
    // ROULETTE - VOTING UI
    // ============================================
    showRouletteVoting: function (state, mySessionId) {
        this.ensureElements();
        if (!this.elements.optionsContainer || !this.elements.questionText) return;

        const victimName = state.victimName || 'Oyuncu';
        const isVictim = (mySessionId === state.victimSessionId);

        // Update question area with voting prompt
        if (isVictim) {
            this.elements.questionText.innerHTML = `
                <div style="text-align:center">
                    <div style="font-size:1.5rem; margin-bottom:10px;">⚠️ YANLIŞ CEVAP!</div>
                    <div style="font-size:1.2rem; color:#e74c3c;">Diğer oyuncular senin hakkında oy veriyor...</div>
                    <div style="font-size:1rem; margin-top:10px; color:rgba(255,255,255,0.6);">Affet mi? İnfaz mı?</div>
                </div>`;
            this.elements.optionsContainer.innerHTML = `
                <div style="text-align:center; padding:20px; color:rgba(255,255,255,0.5); font-size:1.1rem;">
                    ⏳ Oylama sonuçlanması bekleniyor...
                </div>`;
        } else {
            this.elements.questionText.innerHTML = `
                <div style="text-align:center">
                    <div style="font-size:1.5rem; margin-bottom:10px;">🗳️ OY VERME ZAMANI!</div>
                    <div style="font-size:1.2rem;"><span style="color:#e74c3c; font-weight:bold;">${victimName}</span> yanlış cevapladı!</div>
                    <div style="font-size:1rem; margin-top:10px; color:rgba(255,255,255,0.6);">Ne yapılmalı?</div>
                    <div style="font-size:0.8rem; margin-top:5px; color:rgba(255,255,255,0.4);">Affet: ${state.voteCountAffet} - İnfaz: ${state.voteCountInfaz}</div>
                </div>`;

            // Check if already voted
            const alreadyVoted = this._rouletteVoted;
            if (alreadyVoted) {
                this.elements.optionsContainer.innerHTML = `
                    <div style="text-align:center; padding:20px; color:var(--accent-gold); font-size:1.1rem;">
                        ✅ Oyun verildi! Diğer oylar bekleniyor...
                    </div>`;
            } else {
                this.elements.optionsContainer.innerHTML = '';

                // AFFET Button
                const affetBtn = document.createElement('button');
                affetBtn.className = 'option-btn';
                affetBtn.innerHTML = '😇 AFFET';
                affetBtn.style.cssText = 'background: linear-gradient(135deg, #27ae60, #2ecc71); color: white; font-size: 1.2rem; font-weight: 900; border: 2px solid #27ae60; min-height: 60px;';
                affetBtn.onclick = () => {
                    const activeRoom = this.currentRoom || (window.multiplayer && window.multiplayer.room);
                    if (activeRoom) {
                        activeRoom.send('rouletteVote', 'affet');
                        this._rouletteVoted = true;
                        this.elements.optionsContainer.innerHTML = '<div style="text-align:center; padding:20px; color:#2ecc71; font-size:1.1rem;">😇 AFFET oyu verildi!</div>';
                    }
                };

                // İNFAZ Button
                const infazBtn = document.createElement('button');
                infazBtn.className = 'option-btn';
                infazBtn.innerHTML = '💀 İNFAZ ET';
                infazBtn.style.cssText = 'background: linear-gradient(135deg, #c0392b, #e74c3c); color: white; font-size: 1.2rem; font-weight: 900; border: 2px solid #c0392b; min-height: 60px;';
                infazBtn.onclick = () => {
                    const activeRoom = this.currentRoom || (window.multiplayer && window.multiplayer.room);
                    if (activeRoom) {
                        activeRoom.send('rouletteVote', 'infaz');
                        this._rouletteVoted = true;
                        this.elements.optionsContainer.innerHTML = '<div style="text-align:center; padding:20px; color:#e74c3c; font-size:1.1rem;">💀 İNFAZ oyu verildi!</div>';
                    }
                };

                this.elements.optionsContainer.appendChild(affetBtn);
                this.elements.optionsContainer.appendChild(infazBtn);
            }
        }

        // Update timer
        if (this.elements.timeDisplay) {
            this.elements.timeDisplay.innerText = state.votingCountdown;
        }
    },

    // [ROULETTE] Show event messages (elimination, win, etc.)
    showRouletteMessage: function (data) {
        this.ensureElements();
        if (!this.elements.questionText) return;

        const type = data.type;
        let icon = '🎰';
        let color = '#fff';

        switch (type) {
            case 'all_correct': icon = '✅'; color = '#2ecc71'; break;
            case 'multi_elimination': icon = '💀'; color = '#e74c3c'; break;
            case 'instant_win': icon = '🏆'; color = '#f1c40f'; break;
            case 'all_wrong': icon = '☠️'; color = '#e74c3c'; break;
            case 'vote_result_infaz': icon = '💀'; color = '#e74c3c'; if (window.audio) window.audio.playSound('infaz'); break;
            case 'vote_result_affet':
                icon = '😇';
                color = '#2ecc71';
                // [NEW] Only the forgiven player hears 'kefen.mp3'
                if (window.audio) {
                    const myRoom = window.multiplayer && window.multiplayer.room;
                    const mySessionId = myRoom ? myRoom.sessionId : null;
                    const activeRoom = this.currentRoom || myRoom;
                    const victimId = (activeRoom && activeRoom.state) ? activeRoom.state.victimSessionId : null;

                    if (mySessionId === victimId) {
                        // Stop any other sounds before playing kefen to avoid clash
                        // In this game, usually sound effects are brief and don't overlap much,
                        // but we play it explicitly here.
                        window.audio.playSound('affet');
                    }
                }
                break;
            case 'voting_start': icon = '🗳️'; color = '#3498db'; this._rouletteVoted = false; break;
            case 'survivors_win': icon = '🎉'; color = '#f1c40f'; break;
            case 'winner': icon = '🏆'; color = '#f1c40f'; break;
            case 'no_winner': icon = '💀'; color = '#e74c3c'; break;
        }

        // Show a brief overlay message
        let overlay = document.getElementById('roulette-event-overlay');
        if (!overlay) {
            overlay = document.createElement('div');
            overlay.id = 'roulette-event-overlay';
            overlay.style.cssText = `
                position: fixed; top: 0; left: 0; width: 100%; height: 100%;
                display: flex; align-items: center; justify-content: center;
                background: rgba(0,0,0,0.7); z-index: 9999;
                animation: fadeIn 0.3s ease;
                pointer-events: none;
            `;
            document.body.appendChild(overlay);
        }

        overlay.innerHTML = `
            <div style="text-align:center; animation: scaleIn 0.3s ease;">
                <div style="font-size:4rem;">${icon}</div>
                <div style="font-size:1.5rem; color:${color}; font-weight:900; margin-top:10px; text-shadow: 0 2px 10px rgba(0,0,0,0.5);">
                    ${data.message}
                </div>
            </div>
        `;
        overlay.style.display = 'flex';

        // Auto-hide after 3 seconds
        setTimeout(() => {
            if (overlay) overlay.style.display = 'none';
        }, 3000);
    },

    reset: function () {
        console.log("[OnlineGameUI] Resetting UI state...");
        this.lastQuestionText = null;
        this.isTyping = false;
        if (this.typewriterTimeout) clearTimeout(this.typewriterTimeout);
        this.resultSoundPlayed = false;
        this.gameOverSoundPlayed = false; // [RESET]
        this.lastTimerVal = -1; // [RESET]
        this.timeUpPlayed = false; // [RESET]
        this._rouletteVoted = false; // [ROULETTE RESET]

        // Reset elements if they exist
        this.ensureElements();
        if (this.elements.questionText) this.elements.questionText.innerText = "";
        if (this.elements.optionsContainer) this.elements.optionsContainer.innerHTML = "";
        if (this.elements.timeDisplay) this.elements.timeDisplay.innerText = "";
        if (this.elements.categoryDisplay) this.elements.categoryDisplay.innerText = "";

        // [ROULETTE] Remove event overlay if exists
        const rouletteOverlay = document.getElementById('roulette-event-overlay');
        if (rouletteOverlay) rouletteOverlay.remove();

        // Ensure header info is restored
        if (this.elements.timeDisplay) this.elements.timeDisplay.parentElement.style.opacity = '1';
        if (this.elements.categoryDisplay) this.elements.categoryDisplay.style.opacity = '1';
        const questionIndexEl = document.querySelector('.header-question-info');
        if (questionIndexEl) questionIndexEl.style.opacity = '1';
    }
};

window.OnlineGameUI = OnlineGameUI;
